/**
 * @fileoverview Deliverable drawer skeleton, mirroring StudentDeliverableSection
 * 1:1: project/lesson bar (p="md", two lines + "Created by"), title row with
 * badge, due date, instructions label + lines, then the "Your delivery"
 * textarea, "Your files" label and upload + GDrive button rows. No footer
 * (submit lives in the fixed drawer footer and is hidden while loading).
 */

import { Group, Paper, Skeleton, Stack } from '@mantine/core'
import { SKELETON } from '../../constants'

const { infoBar, deliverable } = SKELETON

export function DeliverableDrawerSkeleton() {
  return (
    <Stack spacing="lg">
      <Paper withBorder radius="sm" p="md">
        <Group position="apart" align="flex-start" noWrap>
          <Stack spacing={2}>
            <Skeleton height={infoBar.line.height} width={infoBar.line.width} />
            <Skeleton height={infoBar.line.height} width={infoBar.line.width} />
          </Stack>
          <Skeleton height={infoBar.side.height} width={infoBar.side.width} />
        </Group>
      </Paper>

      <Stack spacing="xs">
        <Group spacing="xs" align="center" noWrap>
          <Skeleton height={deliverable.title.height} width={deliverable.title.width} />
          <Skeleton height={deliverable.badge.height} width={deliverable.badge.width} radius="xl" />
        </Group>
        <Skeleton height={deliverable.due.height} width={deliverable.due.width} />
        <Skeleton height={deliverable.label.height} width={deliverable.label.width} />
        {deliverable.instructionWidths.map((width, index) => (
          <Skeleton key={index} height={deliverable.instructionLine.height} width={width} />
        ))}
      </Stack>

      <Stack spacing="sm">
        <Stack spacing={4}>
          <Skeleton height={deliverable.label.height} width={deliverable.label.width} />
          <Skeleton height={deliverable.textarea.height} radius="sm" />
        </Stack>
        <Skeleton height={deliverable.label.height} width={deliverable.label.width} />
        <Stack spacing="sm">
          <Skeleton height={deliverable.uploadButton.height} width={deliverable.uploadButton.width} />
          <Skeleton height={deliverable.gdriveButton.height} width={deliverable.gdriveButton.width} />
        </Stack>
      </Stack>
    </Stack>
  )
}
